import React from 'react';
import { Link } from 'react-router-dom';
import { PageHero } from '../components/ui/PageHero';
import { consultants } from '../data/consultants';
import { articles } from '../data/insights';
import { legalNav, mobileNav } from '../data/navigation';
import { usePageMeta } from '../hooks/usePageMeta';
const groups = [{
  title: 'Main pages',
  links: mobileNav
}, {
  title: 'Consultant profiles',
  links: consultants.map(c => ({
    label: c.name,
    to: `/consultants/${c.slug}`
  }))
}, {
  title: 'Insights',
  links: articles.map(a => ({
    label: a.title,
    to: `/insights/${a.slug}`
  }))
}, {
  title: 'Legal & policies',
  links: legalNav.filter(l => l.to !== '/sitemap')
}];
export function Sitemap() {
  usePageMeta('Sitemap', 'An overview of every page on the Aurevane Search Partners website.');
  return <>
      <PageHero compact label="Sitemap" title="Every page, in one place" data-id="element-982" data-mp="33d9ij4agsvp0" />
      <section className="bg-porcelain py-16 lg:py-24" data-id="element-983" data-mp="38arsmy07xgyl">
        <div className="mx-auto grid max-w-7xl gap-12 px-6 sm:grid-cols-2 lg:grid-cols-4 lg:px-10" data-id="element-984" data-mp="3896wx5263rz5">
          {groups.map(g => <nav key={g.title} aria-label={g.title} data-id="element-985" data-mp="261v3kesz5squ">
              <h2 className="font-display text-lg font-semibold text-aubergine" data-id="element-986" data-mp="260a90p6nu9sz">{g.title}</h2>
              <ul className="mt-5 space-y-3 border-t border-plum/10 pt-5" data-id="element-987" data-mp="2130ljf2u087s">
                {g.links.map(l => <li key={l.to} data-id="element-988" data-mp="1x3003ahbewr8">
                    <Link to={l.to} className="text-sm leading-snug text-plum/75 hover:text-copper-deep" data-id="element-989" data-mp="2trpgewdanhb3">
                      {l.label}
                    </Link>
                  </li>)}
              </ul>
            </nav>)}
        </div>
      </section>
    </>;
}